<div class="w-full h-full bg-gray-100 relative">
    <div
        class="fixed inset-0 z-50  overflow-y-auto bg-slate-900/40 backdrop-blur-sm pt-4 pb-20 print:p-0 print:bg-white print:overflow-visible">
        <!-- Floating Action Bar -->
        <div class="relative flex justify-center items-center gap-2 no-print z-50">
            <div class="flex justify-center items-end gap-2">
                <button (click)="print()"
                    class="flex items-center gap-2 px-4 py-2 bg-yellow-400 text-gray-900 rounded-lg shadow-lg hover:bg-yellow-300 font-bold transition-all transform hover:scale-105">
                    <span class="material-icons">print</span>
                    <span>พิมพ์</span>
                </button>
                <button (click)="downloadPDF()" [disabled]="isPdfGenerating"
                    class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg shadow-lg hover:bg-blue-500 font-bold transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed">
                    <span>{{ isPdfGenerating ? 'กำลังสร้าง PDF...' : 'ดาวน์โหลด PDF' }}</span>
                </button>
                <!-- <button (click)="onClose()"
                    class="flex items-center justify-center w-10 h-10 bg-white text-gray-400 rounded-full shadow-lg hover:text-gray-600 transition-all">
                    <span class="material-icons">close</span>
                </button> -->
            </div>
        </div>
        <div class="flex items-start justify-center">

            <div class="a4-page  pdf-safe relative w-full max-w-[210mm] bg-white shadow-2xl"
                (click)="$event.stopPropagation()">



                <div *ngIf="isLoading" class="flex flex-col items-center justify-center min-h-[297mm]">
                    <div class="w-10 h-10 border-4 border-gray-100 border-t-[#002060] rounded-full animate-spin"></div>
                </div>

                <div *ngIf="!isLoading && invoiceDisplay"
                    class="min-h-[297mm] p-[40px] text-[#002060] text-[13px] leading-snug relative  ">

                    <div class="flex justify-between items-start mb-0 w-full">
                        <div class="flex items-center gap-4 w-full">
                            <div class="w-24 h-16 flex-shrink-0">
                                <img src="img/pss-logo.png" alt="PSS Logo" class="w-full h-full object-contain"
                                    onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
                                <div
                                    class="w-full h-full bg-red-800 text-white flex items-center justify-center text-xs font-bold italic hidden">
                                    PSS LOGO
                                </div>
                            </div>

                            <div>
                                <h1 class="text-base font-bold text-[#002060]">บริษัท พีเอสเอส กรุ๊ป (ประเทศไทย) จำกัด
                                </h1>
                                <h2 class="text-sm font-bold text-[#002060] mb-1">PSS GROUP (THAILAND) CO.,LTD.</h2>


                            </div>
                        </div>

                        <div class="w-[25%] flex items-center justify-end">
                            <div class="flex flex-col items-center w-full pt-2">
                                <div
                                    class="border border-[#8B0000] rounded-lg px-6 py-1 min-w-[100px] text-center mb-3">
                                    <span class="text-[#8B0000] font-bold text-xs">({{ isCopy ? 'สำเนา' : 'ต้นฉบับ'
                                        }})</span>
                                </div>
                                <div class="text-center text-[11px] text-[#002060] font-medium">สำหรับลูกค้า</div>
                            </div>
                        </div>
                    </div>
                    <div class="text-[10px] text-[#002060] space-y-0.5 mb-8">
                        <p>สำนักงานใหญ่: 45/4 หมู่ที่ 5 ต.บางเมือง อ.เมืองสมุทรปราการ จ.สมุทรปราการ 10270</p>
                        <p>Head Office: 45/4 Moo5, Bang Mueang, Mueang-Samut Prakan, Samut Prakan 10270</p>
                        <p>โทร. 02-0982255 &nbsp; เลขประจำตัวผู้เสียภาษี 0115560017379</p>
                    </div>

                    <div class="flex justify-center mb-6">
                        <div
                            class="border border-[#002060] rounded-xl px-12 py-2 text-center min-w-[280px] shadow-sm bg-white">
                            <h3 class="font-bold text-[#002060] text-base">ใบแจ้งหนี้</h3>
                            <p class="font-bold text-[#002060] text-sm tracking-widest">INVOICE</p>
                        </div>
                    </div>

                    <div class="grid grid-cols-12 gap-2 mb-4 text-[12px]">
                        <div class="col-span-9 pr-2">
                            <div class="flex mb-1">
                                <span class="w-18 text-gray-600 font-medium">นามลูกค้า</span>
                                <span
                                    class="flex-1 font-bold text-[#002060] border-b border-dotted border-gray-400 px-2 max-w-86">{{
                                    invoiceDisplay.customerName }}</span>
                            </div>
                            <div class="flex mb-1 items-start ">
                                <span class="w-18 text-gray-600 font-medium">ที่อยู่</span>
                                <div
                                    class="flex-1 text-gray-800 leading-relaxed  border-b border-dotted border-gray-400 px-2 max-w-86">
                                    {{ invoiceDisplay.customerAddress }}
                                    <!-- <span *ngIf="!invoiceDisplay.customerAddress">
                                        อาคาร เพียร์ 111 ห้องเลขที่ 1104 ชั้นที่ 11 เลขที่ 111 <br>
                                        ถนน ราชดำริห์ แขวง ลุมพินี เขตปทุมวัน จังหวัด กรุงเทพมหานคร 10330
                                    </span> -->
                                </div>
                            </div>
                            <div class="flex items-center mt-2">
                                <span class="w-32 text-gray-600 font-medium">เลขประจำตัวผู้เสียภาษี</span>
                                <span
                                    class="font-mono font-medium text-[#002060] tracking-wider mr-6 border-b border-dotted border-gray-400  px-2">
                                    {{ invoiceDisplay.customerTaxId || '0105549060565' }}
                                </span>

                                <div class="flex items-center gap-4">
                                    <div class="flex items-center gap-1.5 cursor-pointer">
                                        <div
                                            class="w-4 h-4 border border-black flex items-center justify-center relative bg-white">
                                            <span *ngIf="!invoiceDisplay.customerBranch "
                                                class="text-black font-bold text-xs absolute inset-0 flex items-center justify-center pb-0.5">X</span>
                                        </div>
                                        <span class="text-xs text-black">สำนักงานใหญ่</span>
                                    </div>

                                    <div class="flex items-center gap-1.5 cursor-pointer">
                                        <div
                                            class="w-4 h-4 border border-black flex items-center justify-center relative bg-white min-w-4">
                                            <span
                                                *ngIf="invoiceDisplay.customerBranch && invoiceDisplay.customerBranch !== '00000'"
                                                class="text-black font-bold text-xs absolute inset-0 flex items-center justify-center pb-0.5">X</span>
                                        </div>
                                        <span class="text-xs text-black min-w-10">สาขาที่</span>
                                        <div
                                            class="border-b border-dotted border-gray-400  px-2 min-w-10 text-center h-4 leading-none text-xs w-full">
                                            {{ (invoiceDisplay.customerBranch && invoiceDisplay.customerBranch !==
                                            '00000')
                                            ?
                                            invoiceDisplay.customerBranch : '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-3 pl-4 pt-1">
                            <div class="flex justify-between items-center gap-2 mb-1">
                                <span class="font-medium text-gray-600 w-10">เลขที่</span>
                                <span
                                    class="font-medium text-[#002060] text-center border-b border-dotted border-gray-400  px-2 min-w-30">{{
                                    invoiceDisplay.invoiceNo }}</span>
                            </div>
                            <div class="flex justify-center items-center gap-2 pb-1 ">
                                <span class="font-medium text-gray-600 w-10">วันที่</span>
                                <span
                                    class="font-medium text-[#002060] text-center border-b border-dotted border-gray-400  px-2 min-w-30">{{
                                    invoiceDisplay.invoiceDate | date:'dd/MM/yy'
                                    }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="border border-[#3e8ec2] mb-0 min-h-[400px] flex flex-col">
                        <table class="w-full text-[12px]">
                            <thead>
                                <tr class="text-[#002060] border-b border-[#3e8ec2]">
                                    <th class="py-2 w-12 text-center font-bold border-r border-[#3e8ec2]">ลำดับ</th>
                                    <th class="py-2 text-center font-bold border-r border-[#3e8ec2]">รายการ</th>
                                    <th class="py-2 w-20 text-center font-bold border-r border-[#3e8ec2]">จำนวน</th>
                                    <th class="py-2 w-28 text-center font-bold border-r border-[#3e8ec2]">ราคา/หน่วย
                                    </th>
                                    <th class="py-2 w-32 text-center font-bold">จำนวนเงิน</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of invoiceDisplay.items; let i = index">
                                    <td class="py-2 text-center align-top border-r border-[#3e8ec2] h-7">{{ i + 1 }}
                                    </td>
                                    <td class="py-2 px-3 align-top border-r border-[#3e8ec2]">
                                        <p class="font-bold text-[#002060]">{{ item.name }}</p>
                                        <p class="text-gray-600 whitespace-pre-line">{{ item.description }}</p>
                                    </td>
                                    <td class="py-2 text-center align-top border-r border-[#3e8ec2]">{{ item.quantity }}
                                    </td>
                                    <td class="py-2 text-right px-2 align-top border-r border-[#3e8ec2]">{{
                                        item.pricePerUnit|
                                        number:'1.2-2' }}</td>
                                    <td class="py-2 text-right px-2 align-top font-medium">{{ item.totalPrice|
                                        number:'1.2-2' }}
                                    </td>
                                </tr>

                                <tr class="flex-1 h-full">
                                    <td class="border-r border-[#3e8ec2] h-full min-h-[20px]"></td>
                                    <td class="border-r border-[#3e8ec2]"></td>
                                    <td class="border-r border-[#3e8ec2]"></td>
                                    <td class="border-r border-[#3e8ec2]"></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="flex-grow flex">
                            <div class="w-12 border-r border-[#3e8ec2]"></div>
                            <div class="flex-1 border-r border-[#3e8ec2]"></div>
                            <div class="w-20 border-r border-[#3e8ec2]"></div>
                            <div class="w-28 border-r border-[#3e8ec2]"></div>
                            <div class="w-32"></div>
                        </div>
                    </div>

                    <div class="border-x border-b border-[#3e8ec2] grid grid-cols-12 text-[12px] mb-8">

                        <div class="col-span-8 border-r border-[#3e8ec2]">
                            <div class="flex items-center px-3 py-1.5 border-b border-[#3e8ec2] bg-[#f0f8ff]/30">
                                <span class="font-bold text-[#002060] mr-4 whitespace-nowrap">ตัวอักษร:</span>
                                <span class="font-medium text-gray-800 text-center w-full">({{ invoiceDisplay.bahtText
                                    ||
                                    'หนึ่งหมื่นเจ็ดร้อยบาทถ้วน' }})</span>
                            </div>

                            <div class="p-3">
                                <div class="mb-3">
                                    <span class="font-bold text-[#002060] underline">หมายเหตุ :</span>
                                    <p class="text-gray-700 mt-1 pl-2">{{ invoiceDisplay.remark || '-' }}</p>
                                </div>

                                <div class="text-xs leading-relaxed text-[#002060]">
                                    <p class="font-bold">กรุณาโอนชำระเงิน ผ่านธนาคาร กสิกรไทย สาขา โลตัส ศรีนครินทร์</p>
                                    <p>ชื่อบัญชี <span class="font-bold">บริษัท พีเอสเอส กรุ๊ป (ประเทศไทย) จำกัด</span>
                                    </p>
                                    <p>เลขที่บัญชี <span class="font-bold text-base ml-2">196-1-94629-4</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-4 flex flex-col justify-between">
                            <div>
                                <div class="flex justify-between items-center px-3 py-2 border-b border-[#3e8ec2]">
                                    <span class="text-[#002060] font-medium">รวมเป็นเงิน (ก่อนภาษี)</span>
                                    <span class="font-mono font-medium">{{ invoiceDisplay.subTotal | number:'1.2-2'
                                        }}</span>
                                </div>
                                <div class="flex justify-between items-center px-3 py-2 border-b border-[#3e8ec2]">
                                    <span class="text-[#002060] font-medium">ภาษีมูลค่าเพิ่ม {{ vatSetting.rateLabel() }}%</span>
                                    <span class="font-mono font-medium">{{ invoiceDisplay.vat | number:'1.2-2' }}</span>
                                </div>
                            </div>

                            <div class="flex justify-between items-center px-3 py-3 bg-[#f0f8ff]/30">
                                <span class="text-[#002060] font-bold">รวมจำนวนเงินทั้งสิ้น</span>
                                <span class="font-mono font-bold text-lg text-[#002060]">{{ invoiceDisplay.grandTotal |
                                    number:'1.2-2' }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-between items-end mt-4 mb-8 px-4">
                        <div class="w-[40%] text-center">
                            <div class="h-12 border-b border-dotted border-gray-400 mb-2"></div>
                            <p class="text-sm font-bold text-[#002060] mb-6">ผู้รับใบแจ้งหนี้</p>
                            <p class="text-xs text-gray-500">............../............../..............</p>
                        </div>

                        <div class="w-[40%] text-center relative">
                            <div class="text-[10px] text-gray-500 absolute -top-8 right-0 text-right w-full">บริษัท
                                พีเอสเอส
                                กรุ๊ป (ประเทศไทย) จำกัด</div>

                            <div class="h-12 border-b border-dotted border-gray-400 mb-2 relative"></div>
                            <p class="text-sm font-bold text-[#002060] mb-6">ผู้ออกใบแจ้งหนี้</p>
                            <p class="text-xs text-gray-500">............../............../..............</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>